var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8841 17.8245L14.9291 14.7709L14.8621 14.6609C14.7314 14.5218 14.5569 14.4472 14.3721 14.4472C14.1908 14.4472 14.0129 14.5218 13.8856 14.6609C11.3741 17.0963 7.50626 17.2281 4.84345 14.969C2.18065 12.7072 1.55319 8.75813 3.37624 5.73722C5.19929 2.71722 8.90642 1.56449 12.0385 3.04177C15.1715 4.51904 16.759 8.16813 15.7457 11.5709C15.6752 11.8199 15.7319 12.0863 15.9029 12.2745C16.0714 12.4627 16.3267 12.5409 16.5682 12.4836C16.8097 12.4272 17.0049 12.2381 17.0788 11.9936C18.2873 7.95631 16.4608 3.60995 12.7812 1.7654C9.10067 -0.0764161 4.66897 1.13813 2.35599 4.62449C0.0421516 8.11177 0.538956 12.8209 3.52752 15.7118C6.51179 18.599 11.0922 18.7972 14.3017 16.1772L16.9172 18.8827C17.1862 19.1636 17.622 19.1636 17.8945 18.8827C18.1626 18.6018 18.1626 18.1472 17.8945 17.8636L17.8841 17.8245Z",
    fill: "#FDA214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill1);
export default __webpack_public_path__ + "static/media/Fill 1.4a8444f0f83269a9758e184930c916c6.svg";
export { ForwardRef as ReactComponent };